import type H from '@here/maps-api-for-javascript';

/** HERE treats IPoint.alt as 3D height; compound CAD overlays sit on the ground. */
export const toGroundPoint = (point: H.geo.IPoint): H.geo.IPoint => ({
  lat: point.lat,
  lng: point.lng,
});
